import { useEffect } from 'react';
import { pushContentGroup, ContentGroup } from 'src/gtm';

type ContentGroupProps = {
  pageGroup: ContentGroup;
};

export const ContentGroupTracker: React.FC<ContentGroupProps> = ({
  pageGroup,
}) => {
  useEffect(() => {
    pushContentGroup(pageGroup);
  }, [pageGroup]);

  return null;
};

export default ContentGroupTracker;
